import { render, staticRenderFns } from "./location-info.vue?vue&type=template&id=edaa3082"
import script from "./location-info.vue?vue&type=script&lang=js"
export * from "./location-info.vue?vue&type=script&lang=js"
import style0 from "./location-info.vue?vue&type=style&index=0&id=edaa3082&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports